import { InvoiceActivity } from '../billing/billing.types';
import { ActivityCard } from './ActivityCard';

type ActivitiesListProps = {
  activities: InvoiceActivity[];
};

export const ActivitiesList = ({ activities }: ActivitiesListProps) => {
  return (
    <div className="flex flex-col gap-3">
      {activities.map((activity) => (
        <ActivityCard key={activity.id} activity={activity} />
      ))}
    </div>
  );
};
